import { ComponentPropsWithoutRef, PropsWithChildren } from "react";
import * as styles from "./CardCallout.css";
import { Heading } from "~/components/elements/Heading";
import PortableText, {
  IPortableText,
} from "~/components/portableText/PortableText";
import { ButtonLink } from "~/components/elements/ButtonLink";
import { CardCallout as ICardCallout } from "~/sanity/types";
import clsx from "clsx";

// @ts-ignore
import ArrowOutward from "@material-design-icons/svg/filled/arrow_outward.svg?react";

export type CardCalloutProps = ComponentPropsWithoutRef<"div"> &
  PropsWithChildren & {
    card: ICardCallout;
    theme?: "dark" | "colour";
  };

export const CardCallout = ({
  theme = "colour",
  card,
  ...props
}: CardCalloutProps) => {
  const { title, text, links } = card;
  const { className } = props;
  return (
    <div className={clsx(className, styles.card({ theme: theme }))}>
      <div className={styles.text}>
        {title && (
          <div className={styles.heading}>
            <Heading as="h3" size={theme == "dark" ? "h3" : "h1"} uppercase>
              {title}
            </Heading>
          </div>
        )}
        <PortableText blocks={text as IPortableText} />
      </div>
      {links && (
        <div className={styles.buttonContainer}>
          {links.map((link, index) => (
            <ButtonLink
              isPrimary={false}
              theme="light"
              link={link}
              key={index}
              icons={{ iconPrimary: <ArrowOutward /> }}
            >
              {link.text}
            </ButtonLink>
          ))}
        </div>
      )}
    </div>
  );
};
